import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sx" }
const _hoisted_2 = {
  class: "sx-card",
  "aria-labelledby": "dp-list-title"
}
const _hoisted_3 = { class: "sx-list-head" }
const _hoisted_4 = { id: "dp-list-title" }
const _hoisted_5 = { class: "sx-count" }
const _hoisted_6 = { class: "dp-head-actions" }
const _hoisted_7 = { class: "sx-search" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "sx-load-error",
  role: "alert"
}
const _hoisted_10 = {
  key: 2,
  class: "sx-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "sx-rows"
}
const _hoisted_12 = {
  class: "sx-avatar",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "sx-main" }
const _hoisted_14 = {
  key: 0,
  class: "sx-code"
}
const _hoisted_15 = {
  key: 1,
  class: "dp-url"
}
const _hoisted_16 = { class: "sx-meta" }
const _hoisted_17 = {
  key: 0,
  class: "sx-tag tone-driver",
  title: "Livreur établi comme prestataire (depuis la liste des utilisateurs)"
}
const _hoisted_18 = {
  key: 1,
  class: "sx-tag tone-warning",
  title: "Lier un livreur pour que ce prestataire soit proposé à l'expédition"
}
const _hoisted_19 = {
  key: 2,
  class: "sx-tag tone-warning",
  title: "Renseigner l'URL de l'API et l'endpoint pour pouvoir l'utiliser à l'expédition"
}
const _hoisted_20 = { class: "sx-tag tone-info" }
const _hoisted_21 = { class: "sx-tag" }
const _hoisted_22 = { class: "sx-actions" }
const _hoisted_23 = ["aria-label", "title", "onClick"]
const _hoisted_24 = ["aria-label", "title", "onClick"]
const _hoisted_25 = ["aria-label", "onClick"]
const _hoisted_26 = ["aria-label", "title", "disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!
  const _component_DeliveryProviderFormModal = _resolveComponent("DeliveryProviderFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("header", { class: "sx-head" }, [
      _createElementVNode("span", { class: "sx-eyebrow" }, "Paramètres"),
      _createElementVNode("h1", { class: "sx-title" }, "Prestataires"),
      _createElementVNode("p", { class: "sx-sub" }, " Configuration des prestataires de livraison : à l'expédition d'un bon d'envoi, ses colis sont créés automatiquement chez le prestataire choisi via son API. ")
    ], -1)),
    _createVNode(_component_SettingsNav),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _cache[2] || (_cache[2] = _createTextVNode("Prestataires ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.providers.length), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("i", {
              class: "ph ph-magnifying-glass",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              placeholder: "Rechercher un prestataire…",
              "aria-label": "Rechercher un prestataire"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("span", {
                key: n,
                class: "sx-skel"
              })
            }), 64))
          ]))
        : (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("i", {
                class: "ph ph-warning-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[5] || (_cache[5] = _createTextVNode(" Impossible de charger les prestataires. ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchProviders && _ctx.fetchProviders(...args)))
              }, "Réessayer")
            ]))
          : (!_ctx.filtered.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createElementVNode("i", {
                  class: "ph ph-plugs-connected",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.search ? "Aucun prestataire ne correspond à votre recherche." : "Aucun prestataire configuré pour le moment."), 1)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    class: _normalizeClass(["sx-row", { 'is-new': item.id === _ctx.lastSavedId }])
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.initials(item.name)), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                      _createElementVNode("small", null, [
                        (item.code)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.code), 1))
                          : _createCommentVNode("", true),
                        (item.api_base_url)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.api_base_url), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sx-tag", item.active ? 'tone-success' : 'tone-muted'])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", item.active ? 'ph-check-circle' : 'ph-pause-circle']),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(item.active ? "Actif" : "Inactif"), 1)
                      ], 2),
                      (item.user_id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", {
                              class: "ph ph-moped",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode("Livreur" + _toDisplayString(item.driver_name && item.driver_name !== item.name ? ` · ${item.driver_name}` : ""), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!item.user_id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[8] || (_cache[8] = [
                            _createElementVNode("i", {
                              class: "ph ph-link-simple-break",
                              "aria-hidden": "true"
                            }, null, -1),
                            _createTextVNode("Aucun livreur lié ", -1)
                          ])))
                        : _createCommentVNode("", true),
                      (!item.api_configured)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", {
                              class: "ph ph-plugs",
                              "aria-hidden": "true"
                            }, null, -1),
                            _createTextVNode("API non configurée ", -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_20, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", {
                          class: "ph ph-key",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.authLabel(item.api_auth_type)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_21, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", {
                          class: "ph ph-paper-plane-tilt",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(Number(item.bons) || 0), 1),
                        _cache[12] || (_cache[12] = _createTextVNode(" bon(s)", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn",
                        "aria-label": item.active ? `Désactiver ${item.name}` : `Activer ${item.name}`,
                        title: item.active ? 'Désactiver' : 'Activer',
                        onClick: ($event: any) => (_ctx.toggle(item))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", item.active ? 'ph-toggle-right' : 'ph-toggle-left']),
                          "aria-hidden": "true"
                        }, null, 2)
                      ], 8, _hoisted_23),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn",
                        "aria-label": item.user_id ? `Dissocier ${item.name} de son livreur` : `Lier ${item.name} à un livreur`,
                        title: item.user_id ? 'Dissocier du livreur' : 'Lier à un livreur',
                        onClick: ($event: any) => (item.user_id ? _ctx.unlink(item) : _ctx.linkDriver(item))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", item.user_id ? 'ph-link-break' : 'ph-link']),
                          "aria-hidden": "true"
                        }, null, 2)
                      ], 8, _hoisted_24),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn",
                        "aria-label": `Modifier ${item.name}`,
                        title: "Modifier",
                        onClick: ($event: any) => (_ctx.openForm(item))
                      }, _cache[13] || (_cache[13] = [
                        _createElementVNode("i", {
                          class: "ph ph-pencil-simple",
                          "aria-hidden": "true"
                        }, null, -1)
                      ]), 8, _hoisted_25),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn is-danger",
                        "aria-label": `Supprimer ${item.name}`,
                        title: Number(item.bons) > 0 ? 'Impossible : prestataire utilisé par des bons' : 'Supprimer',
                        disabled: Number(item.bons) > 0,
                        onClick: ($event: any) => (_ctx.remove(item))
                      }, _cache[14] || (_cache[14] = [
                        _createElementVNode("i", {
                          class: "ph ph-trash",
                          "aria-hidden": "true"
                        }, null, -1)
                      ]), 8, _hoisted_26)
                    ])
                  ], 2))
                }), 128))
              ]))
    ]),
    _createVNode(_component_DeliveryProviderFormModal, {
      ref: "formModal",
      onSaved: _ctx.onSaved
    }, null, 8, ["onSaved"])
  ]))
}